import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'areaFieldFieldSector',
})
export class AreaFieldFieldSectorPipe implements PipeTransform {
  transform(value: string, field: string | undefined, fieldSector: string | undefined): string {
    return `${value},${field},${fieldSector}`;
  }
}
